const initialState = {
  searchPersists: {
    organisation: {
      searchField: "Select",
      searchValue: "All",
    },
    UserManagement: {
      searchField: "Select",
      searchValue: "All",
    },
  },
  isLoading: false,
  taggedCollection: [],
  valueHelp: {}
};

const SearchDataListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_PERSISTS_SEARCH":
      return {
        ...state,
        searchPersists: {
          ...state.searchPersists,
          [payload.moduleId]: payload.searchParams,
        },
        // [payload.moduleId]: payload.searchParams,
      };

    case "TAGGED_COLLECTION":
      return {
        ...state,
        taggedCollection: payload,
      };
    case "LOADING":
      return {
        ...state,
        isLoading: payload,
      };
    case "VALUE_HELP": 
    return {
      ...state,
      valueHelp: payload
    }  

    default:
      return state;
  }
};

export default SearchDataListReducer;
